import React from "react";

function BoardBlock({ board_members }) {
    return (
        <div className="employees-block bgwhite py">
            <div className="container-fluid py-0">
                <div className='row'>
                    <div className='col-xl-4 col-lg-6'>
                        <span className='eyebrow'>Hluthafar og stjórn</span>
                        <h2 className='light title'>Stjórn</h2>
                    </div>
                </div>
                <div className="row">
                    {board_members.map((board, index) => (
                        <div key={index} className="col-lg-4 employee">
                            {board.image && (
                                <img
                                    src={board.image}
                                    alt={board.name}
                                    className="employee-image w-100 mb-24"
                                />
                            )}
                            <h4 className="employee-name light mb-24">{board.name}</h4>
                            {board.text && (
                                <div
                                    className="employee-text p-body-3"
                                    dangerouslySetInnerHTML={{ __html: board.text }}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default BoardBlock;
